import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { BpgCommonService } from '../services/bpg-common.service';
import { DataService } from '../services/data.services';

@Component({
  selector: 'app-header',
  templateUrl: './bpg-header.component.html',
  styleUrls: ['./bpg-header.component.css']
})
export class BpgHeaderComponent implements OnInit{
  navbarOpen = false;
  logindatas: string;
  userFirstName: string;
  userLastName: string;
  siteName: string;
  userSiteId: any;
  getUserSiteDetails: any;
  headerRefresh: boolean;
  loginError: boolean;
  loginData: any;
  userData: string;
  userIdDto: any;
  userRoleDetails: any;
  isSiteAffected: boolean;

  constructor(
    private readonly router: Router,
    private readonly bpgCommonService: BpgCommonService,
    private readonly dataService: DataService
  ) {


    this.bpgCommonService.loginError.subscribe(value => {
      this.loginError = value;
      if (this.loginError === false) {
        this.loginError = false;

      }
    });

      this.bpgCommonService.setloggedInObservable().subscribe(val => {



        if (val) {
         
          this.pageOnLoadFunction()
          // this.getAwsUrls();
        }



      });

  }
  ngOnInit() {
    this.dataService.userData.subscribe(data =>
      {
        this.userData = data;
        if(this.userData!=null){
          this.siteEffectedData();
        }        
      });
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logOut() {
    
    this.router.navigate(['/log-out']);

  }

  public getAwsUrls() {
    const awsDetails = {
      "awsUrl": "",
      "category": "SITE_BANNER"
    }
    this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {

      localStorage.setItem("siteBannerBaseUrl", data.awsUrl);

      const awsDetails = {
        "awsUrl": "",
        "category": "CHAPTER_BANNER"
      }
      this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {
        localStorage.setItem("chapterBannerBaseUrl", data.awsUrl);

        const awsDetails = {
          "awsUrl": "",
          "category": "CHAPTER_LEADERSHIP"
        }
        this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {
          localStorage.setItem("chapterLeadershipBannerBaseUrl", data.awsUrl);
        })
      })
    })


  }

  /** For getting user details on adal
   * @method adalLoginUserDetails
   */
  adalLoginUserDetails() {
    localStorage.setItem("logOutFlag", "false");
    if (!sessionStorage.getItem('userEmail')) {
        this.bpgCommonService.userLogin();
      if (sessionStorage.getItem('userEmail')) {

        const emailDto = {
          "userEmailId": sessionStorage.getItem('userEmail')

        }

        this.bpgCommonService.userDetailsByEmailId(emailDto).subscribe(data => {
          this.loginData = data;

          if (data.emailId === null) {
            this.bpgCommonService.loginError.next(false);
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/login-error']);
          } else {
            localStorage.setItem('loginData', JSON.stringify(this.loginData));
            this.userData = JSON.parse(localStorage.getItem('loginData'));
            this.userIdDto = { "userId": this.userData['userId'] };

            this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {

              this.userRoleDetails = data;
              localStorage.setItem('userSiteId', this.loginData['site']['siteId']);
              localStorage.setItem('adminId', this.userRoleDetails['adminId']);
              localStorage.setItem('selectedSiteId', this.loginData['site']['siteId']);
              localStorage.setItem('leadAdminId', this.userRoleDetails['leadAdminId']);

              window.location.reload();
              this.pageOnLoadFunction();
            })
          }

        })
      }
    }
  }

  pageOnLoadFunction() {

    this.logindatas = JSON.parse(localStorage.getItem('loginData'));
    this.userSiteId = this.logindatas['site']['siteId'];
   
    if (this.userSiteId != null) {
      this.bpgCommonService.getUserSiteDeatils(this.userSiteId).subscribe(data => {
        if(data!=null && data!=undefined){
          this.getUserSiteDetails = (data!=null) ? data : '';
          this.siteName = this.getUserSiteDetails.siteName;
          if (this.logindatas) {
           
            this.userFirstName = this.logindatas['userFirstName'];
            this.userLastName = this.logindatas['userLastName'];
  
          }
          else {
            this.userFirstName = "";
            this.userLastName = "";
          }  
        }      
      });
    }

  }

  manualSiteChange(){
     this.dataService.siteAffectedPopup('true');
  }

  siteEffectedData() {
    const landingData = 
      {
        "filter": {
        "userId":this.userData['userId'],
        "flag": "manualSiteChange"
        }
      }
      this.bpgCommonService.checkSiteAffected(landingData).subscribe(data => {
        if (data && data.isSiteAffected) {
            this.isSiteAffected = true;
        }
         else {
            this.isSiteAffected = false;
         }
      });
  }
}
